import meetingMealService from '../services/meetingMealService';

export const fetchAllMeetingMeals = async ({
  pageNumber = 1,
  pageSize = 20,
  status = null,
  searchTerm = null,
  period = null,
} = {}) => {
  const result = period
    ? await meetingMealService.getMeetingMealsByPeriod(period, { status, pageNumber, pageSize })
    : await meetingMealService.getAllMeetingMeals({ pageNumber, pageSize, status, searchTerm });

  if (!result?.success) {
    const error = new Error(result?.message || 'Yemek borçları alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const fetchMeetingMealById = async (id) => {
  const result = await meetingMealService.getMeetingMealById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Yemek borcu bulunamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchMeetingMealsByMemberId = async (memberId) => {
  const result = await meetingMealService.getMeetingMealsByMemberId(memberId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Üye yemek borçları alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const createMemberMeal = async (payload) => {
  const result = await meetingMealService.createMemberMeal(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Yemek borcu oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const previewBulkCreateMeals = async (payload) => {
  const result = await meetingMealService.previewBulkCreateMeals(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Önizleme alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const startBulkCreateMeals = async (payload) => {
  const result = await meetingMealService.startBulkCreateMeals(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Toplu yemek borçlandırma başlatılamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchBulkCreateMealsStatus = async (jobId) => {
  const result = await meetingMealService.getBulkCreateMealsStatus(jobId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Toplu işlem durumu alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const cancelMeetingMeal = async (payload) => {
  const result = await meetingMealService.cancelMeetingMeal(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Yemek borcu iptal edilemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchSkippedAutomaticMealDebts = async (query = {}) => {
  const result = await meetingMealService.listSkippedAutomaticMealDebts(query);
  if (!result?.success) {
    const error = new Error(result?.message || 'Atlanan kayıtlar alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const downloadSkippedAutomaticMealDebtsCsv = async (query = {}) => {
  const blob = await meetingMealService.exportSkippedAutomaticMealDebtsCsv(query);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `otomatik-yemek-atlanan-${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export default {
  fetchAllMeetingMeals,
  fetchMeetingMealById,
  fetchMeetingMealsByMemberId,
  createMemberMeal,
  previewBulkCreateMeals,
  startBulkCreateMeals,
  fetchBulkCreateMealsStatus,
  cancelMeetingMeal,
  fetchSkippedAutomaticMealDebts,
  downloadSkippedAutomaticMealDebtsCsv,
};
